<template>
    <app-layout title="View Recurring Order">
        <page-header>
            <template #title>View Recurring Order</template>

            <template #actions>
                <div class="flex flex-col sm:flex-row justify-between gap-x-4 gap-y-2">

                    <jet-button v-if="allowEdit" type="button" class="leading-none inline-flex items-center" :href="editUrl">
                        Edit
                    </jet-button>

                    <jet-tertiary-button type="button" class="leading-none" :href="backUrl">
                        Close
                    </jet-tertiary-button>
                </div>
            </template>
        </page-header>

        <div class="flex flex-col px-3 md:px-4 lg:px-8 gap-y-4 ">
            <recurring-order-details :recurringOrder="recurringOrder"/>

            <recurring-order-items :recurringOrder="recurringOrder" />
        </div>

        <div class="text-center py-24" >
            <jet-danger-button @click="showDeleteModal = true">
                    Delete Recurring Order
            </jet-danger-button>
        </div>

        <jet-confirmation-modal :show="showDeleteModal" @close="showDeleteModal=false">
            <template #title>
                Delete Recurring Order
            </template>

            <template #content>
                Are you sure you would like to delete this recurring order? All orders generated from this recurring order will be unaffected - this will only delete the recurring order itself.
            </template>

            <template #footer>
                <jet-danger-button @click="deleteOrder">
                    Yes
                </jet-danger-button>

                <jet-tertiary-button class="ml-2" @click="showDeleteModal=false">
                    No
                </jet-tertiary-button>
            </template>
        </jet-confirmation-modal>

    </app-layout>
</template>

<script>
import { usePage } from '@inertiajs/inertia-vue3';
import UseUserAuth from '@/Composables/UseUserAuth';
import AppLayout from '@/Layouts/AppLayout.vue';
import { DateTime } from "luxon";
import PageHeader from '@/Layouts/partials/PageHeader.vue';
import JetButton from '@/Jetstream/Button';
import JetConfirmationModal from '@/Jetstream/ConfirmationModal';
import JetDangerButton from '@/Jetstream/DangerButton';
import JetDialogModal from '@/Jetstream/DialogModal';
import JetDropdown from '@/Jetstream/Dropdown';
import JetTertiaryButton from '@/Jetstream/TertiaryButton';
import JetSecondaryButton from '@/Jetstream/SecondaryButton';
import RecurringOrderDetails from '@/Pages/RecurringOrders/Partials/RecurringOrderDetails'
import RecurringOrderItems from '@/Pages/RecurringOrders/Partials/RecurringOrderItems'

export default {
    setup () {
        const { isAdmin } = UseUserAuth(usePage().props.value.user);

        return { isAdmin }
    },

    components: {
        AppLayout,
        PageHeader,
        JetButton,
        JetConfirmationModal,
        JetSecondaryButton,
        JetDangerButton,
        JetDialogModal,
        JetDropdown,
        JetTertiaryButton,
        RecurringOrderDetails,
        RecurringOrderItems
    },

    props: ['recurringOrder', 'generatedOrders'],

    data() {
        return {
            showDeleteModal: false,
            showEmailModal: false,
            showInvoicedModal: false,
            showMarkShippedAndInvoicedModal: false,
            showOrderProcessResponseModal: false,
            orderProcessResponse: null,
            emailType: null,
            bcSyncProcessing: false,
        }
    },

    methods: {

        deleteOrder () {
            this.$inertia.visit(route('recurring_orders.destroy', this.recurringOrder.id), {method: 'delete'});
        },

        emailOrder(type) {
            this.emailType = type;
            this.showEmailModal = true;
        },

        handleEmail() {
            this.$inertia.visit(route('orders.email', { order: this.order.id, type: this.emailType }));
        },
    },

    computed: {
        backUrl () {
            const params = route().params;

            if (params.return) {
                return params.return;
            }

            return route('recurring_orders.index', {
                page: this.$page.props.page.recurringOrders,
            });
        },

        editUrl () {
            const params = route().params;

            return route('recurring_orders.edit', {
                recurring_order: this.recurringOrder,
                return: params.return,
            });
        },

        // showEmailButton() {
        //     if (this.order.status === -1) return false;

        //     return this.order.status !== 2
        // },

        allowEdit() {
            // TODO
            // if (!this.order.is_wholesale) {
            //     if (this.order.status == 0) {
            //         return false;
            //     } else {
            //         return true;
            //     }
            // } else {
            //     return true;
            // }
            return true;
        }
    }
}
</script>

<style scoped>

</style>
